import constants from '../constants';

import { getPath, getPathParams } from '../utils';
import { Action } from '../../../types/Global';

const url = window.Alfresco ? window.Alfresco.util.parseURL(window.location.href) : { hash: '', params: [] };

const initialState = {
  hash: url.hash,
  path: getPath(url.hash),
  params: getPathParams(url.hash.split('?')[1]),
  hostname: url.hostname,
  routes: [],
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case constants.SET_ROUTES: {
      return {
        ...state,
        routes: action.payload,
      };
    }

    case constants.CHANGE_ROUTE: {
      const path = action.payload.split('?')[0];
      const params = getPathParams(action.payload.split('?')[1]);

      return {
        ...state,
        path: path,
        hash: `#${path.substr(1)}`,
        params,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
